import React, { useEffect, useState } from "react";
import useTableFijo from "@/components/useTableFijo";
import axios from "axios";
import { Dimmer } from "@/components/spinner";
import { Mensaje } from "@/components/mensajes2";
import { formatMoneda } from "@/util/varios";
import moment from "moment";
export default function TablaMultaLicores(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells = [
    {
      id: "idmulta",
      label: "ID",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "fechamulta",
      label: "FECHA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descripcion",
      label: "TIPO MULTA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "concepto",
      label: "CONCEPTO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "monto",
      label: "MONTO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "cancelada",
      label: "PAGADA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    320,
  );
  const buscarMultas = () => {
    setLoading(true);
    const campos = `*`;
    const tabla = `multa
    where idcontribuyente = ${props.idComercio} and tipoimpuesto = 'RENTAS DE LICORES'`;
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=
      ${campos}&nomtab=${tabla}&orden=idmulta desc`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          setRecords(res.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    buscarMultas();
  }, []);
  return (
    <div className="col-12 m-0 mt-2 p-0">
      <TblContainer
        container={{
          height: 250,
          width: "100%",
          overflow: "auto",
          padding: "2px",
        }}
      >
        <TblHead />
        <tbody>
          {records &&
            records.map((item, index) => (
              <tr key={index} style={{ padding: "0" }}>
                <td style={{ fontSize: "10px", textAlign: "center" }}>
                  {item.idmulta}
                </td>
                <td style={{ fontSize: "10px", textAlign: "center" }}>
                  {moment.utc(item.fechamulta).format("DD/MM/YYYY")}
                </td>
                <td style={{ fontSize: "10px", textAlign: "left" }}>
                  {item.descripcion.trim()}
                </td>
                <td style={{ fontSize: "10px", textAlign: "left" }}>
                  {item.concepto.trim()}
                </td>
                <td style={{ fontSize: "10px", textAlign: "right" }}>
                  {formatMoneda(
                    item.monto.toString().replace(".", ","),
                    ",",
                    ".",
                    2,
                  )}
                </td>
                <td style={{ fontSize: "10px", textAlign: "center" }}>
                  {item.cancelada ? "SI" : "NO"}
                </td>
              </tr>
            ))}
        </tbody>
      </TblContainer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={loading} inverted />
    </div>
  );
}
